export enum QuestionStatus {
    CONCLUIDO = 'CONCLUÍDO',
    PENDENTE = 'PENDENTE',
    PENDENTE_APROVACAO = 'PENDENTE APROVAÇÃO'
}

export enum DataType {
    TEXT = 'TEXT',
    QUERY = 'QUERY'
}

export enum Category {
    SESSAO = 'Sessão',
    USUARIO = 'Usuário',
    CADASTRO = 'Cadastro',
    CUPOM = 'Cupom',
    PARTICIPANTE = 'Participante',
    CESTA_DE_PRODUTOS = 'Cesta de Produtos',
    CNPJ = 'CNPJ',
    MIDIA = 'Mídia',
    QR_CODE = 'QR Code',
    SAC = 'SAC',
    DASHBOARD = 'Dashboard',
    REGULAMENTO = 'Regulamento',
    JUNTE_E_TROQUE = 'Junte e Troque',
    VALE_BRINDE = 'Vale Brinde',
    CASHBACK = 'Cashback',
    SORTEIO = 'Sorteio',
    CONCURSO_CULTURAL = 'Concurso Cultural',
    OUTROS = 'Outros',
}

export enum UserRole {
    ADMIN = 'ADMIN',
    USER_HUB = 'USER_HUB',
    USER_CLIENT_ADMIN = 'USER_CLIENT_ADMIN',
    USER_CLIENT = 'USER_CLIENT',
}

export enum NotificationFrequency {
    DAILY = 'DAILY',
    WEEKLY = 'WEEKLY',
    MONTHLY = 'MONTHLY',
    CRON = 'CRON',
    ONCE = 'ONCE',
}
